import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from './ui/alert-dialog';
import { useRequestTooLargeAlert } from '../lib/installRequestTooLargeAlert';
import { REQUEST_TOO_LARGE_MESSAGE } from '../utils/extract-api-error';

// Max z-index so the alert sits above any open modal or toast. `!` because
// tailwind-merge isn't set up for the `tw-` prefix, so it can't drop the
// default tw-z-50 for us.
const TOP_LAYER = '!tw-z-[2147483647]';

export const RequestTooLargeDialog = () => {
    const [open, setOpen] = useRequestTooLargeAlert();

    return (
        <AlertDialog open={open} onOpenChange={setOpen}>
            <AlertDialogContent className={TOP_LAYER} overlayClassName={TOP_LAYER}>
                <AlertDialogHeader>
                    <AlertDialogTitle>Upload too large</AlertDialogTitle>
                    <AlertDialogDescription>{REQUEST_TOO_LARGE_MESSAGE}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogAction>OK</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
